import {
	SecurityAuthorisedCapitalFormDto,
	SecurityAuthorisedCapitalShape,
} from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/SecurityFeatures/AuthorisedCapital/authorisedCapital.zod.ts';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { DataSecurityWithAllFeaturesAndRanksTct } from '@dealstack/shared/lib/generated';
import { zodResolver } from '@hookform/resolvers/zod';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export enum AUTHORISED_CAPITAL_FORM_FIELD {
	authorisedCapital = 'authorisedCapital',
}

export const useAuthorisedCapitalController = (
	security: DataSecurityWithAllFeaturesAndRanksTct | null,
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>
) => {
	const authorisedCapital = security?.authorisedCapital || undefined;
	const defaultValues = useMemo(
		() => ({
			authorisedCapital,
		}),
		[authorisedCapital]
	);

	const authorisedCapitalForm = useForm<SecurityAuthorisedCapitalFormDto>({
		mode: 'all',
		resolver: zodResolver(SecurityAuthorisedCapitalShape(tCapManage)),
		defaultValues,
		shouldFocusError: false,
	});
	const resetForm = () => {
		authorisedCapitalForm.reset(defaultValues);
	};

	return {
		authorisedCapitalForm,
		resetForm,
	};
};
